import {StringArray} from '../@interfaces/types';
import app from './app';

export default function trans(key: string, locale?: string, defaultValue?: string | null): string;
export default function trans(key: string, replace?: StringArray<string | number>, defaultValue?: string | null, locale?: string): string;
export default function trans(key: string, replace?: string | StringArray<string | number>, defaultValue?: string | null, locale?: string): string {
    if (typeof replace === 'string') {
        locale = replace;
        replace = undefined;
    }

    return app('trans').get(key, replace, defaultValue ?? key, locale) as string;
}
